var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-model"},[_c('img',{staticStyle:{"width":"90px","height":"90px"},attrs:{"src":_vm.staticState+'/static/images/loding1.gif',"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }